import { render, staticRenderFns } from "./register-complete.vue?vue&type=template&id=b30ffd18&"
import script from "./register-complete.vue?vue&type=script&lang=js&"
export * from "./register-complete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports